import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import InstallPrompt from "@/components/InstallPrompt";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import MapPage from "@/pages/MapPage";
import PlaceDetail from "@/pages/PlaceDetail";
import { Login, Register } from "@/pages/Auth";
import MerchantDashboard from "@/pages/MerchantDashboard";
import PlaceForm from "@/pages/PlaceForm";
import Promote from "@/pages/Promote";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Share from "@/pages/Share";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/place/:id" element={<PlaceDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/merchant" element={<MerchantDashboard />} />
            <Route path="/merchant/new" element={<PlaceForm />} />
            <Route path="/merchant/edit/:id" element={<PlaceForm />} />
            <Route path="/merchant/promote/:id" element={<Promote />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/share" element={<Share />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <InstallPrompt />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
